// src/core/lib/api/token.ts — auth-token registry (PRI-439 R13)
//
// Extracted from client.ts so both the legacy request() shim and the SDK
// singleton (sdk.ts) can resolve the current bearer without a circular
// import. Components keep calling setTokenGetter() exactly as before —
// client.ts re-exports these under the original names.

import { getStoredAnonKey } from './anon-key'

let _getToken: (() => Promise<string | null>) | null = null

export function setTokenGetter(fn: () => Promise<string | null>) {
  _getToken = fn
}

/**
 * Resolve the current bearer. Clerk session token wins; when the visitor is
 * anonymous (no Clerk token) we fall back to the stored anon free-grant
 * pv_live_ key (PRI-503 anon trial). The API's triple-accept auth path
 * (Clerk JWT / pv_ key / pvct_ token) handles either on every endpoint.
 * NEVER provisions — a missing anon key stays a null bearer.
 */
export async function getAuthToken(): Promise<string | null> {
  const clerkToken = _getToken ? await _getToken().catch(() => null) : null
  if (clerkToken) return clerkToken
  return getStoredAnonKey()?.apiKey ?? null
}
